var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", [
    _c("div", { staticClass: "app-main-inner-row" }, [
      _c(
        "div",
        { staticClass: "filters" },
        [
          _c(
            "el-form",
            {
              attrs: {
                inline: true,
                "label-width": "100px",
                "label-position": "right"
              }
            },
            [
              _c(
                "div",
                { staticClass: "el-form-item-wrapper" },
                [
                  _c(
                    "el-form-item",
                    {
                      attrs: {
                        "label-width": "50px",
                        label: _vm.$t("SystemMaintenance.Branch")
                      }
                    },
                    [
                      _c(
                        "el-select",
                        {
                          attrs: { no: "1" },
                          on: {
                            change: function($event) {
                              return _vm.getConfig(_vm.branchId)
                            }
                          },
                          model: {
                            value: _vm.branchId,
                            callback: function($$v) {
                              _vm.branchId = $$v
                            },
                            expression: "branchId"
                          }
                        },
                        _vm._l(_vm.currentOfficeList, function(office) {
                          return _c("el-option", {
                            key: office.officeId,
                            attrs: {
                              value: office.officeId,
                              label: office.code
                            }
                          })
                        }),
                        1
                      )
                    ],
                    1
                  ),
                  _c(
                    "el-form-item",
                    {
                      directives: [
                        {
                          name: "show",
                          rawName: "v-show",
                          value: _vm.branchId !== 1,
                          expression: "branchId!==1"
                        }
                      ],
                      attrs: {
                        label: _vm.$t(
                          "SystemMaintenance.ApplyTheHeadOfficesSettings"
                        )
                      }
                    },
                    [
                      _c("el-checkbox", {
                        attrs: { no: "2" },
                        on: { change: _vm.applyHeadOfficeConfig },
                        model: {
                          value: _vm.ifApplied,
                          callback: function($$v) {
                            _vm.ifApplied = $$v
                          },
                          expression: "ifApplied"
                        }
                      })
                    ],
                    1
                  )
                ],
                1
              )
            ]
          ),
          _c("br"),
          _c(
            "el-button",
            {
              staticStyle: { "margin-left": "5px" },
              attrs: { type: "primary", no: "3" },
              on: {
                click: function($event) {
                  return _vm.saveConfig()
                }
              }
            },
            [_vm._v(" " + _vm._s(_vm.$t("common.btn.save")) + " ")]
          )
        ],
        1
      ),
      _c("div", { staticClass: "triggers" })
    ]),
    _c(
      "div",
      {
        ref: "container",
        staticClass: "show-right",
        staticStyle: { height: "90%" },
        attrs: { id: "financial-archiving-settings" }
      },
      [
        _c(
          "div",
          { staticClass: "main-content left", staticStyle: { height: "97%" } },
          [
            _c(
              "div",
              { staticStyle: { "margin-top": "50px", "margin-left": "30px" } },
              [
                _c("span", { staticStyle: { "font-size": "18px" } }, [
                  _vm._v(
                    _vm._s(_vm.$t("CargoMsg.Financial_Filing_Preconditions")) +
                      ":"
                  )
                ]),
                _c(
                  "div",
                  { staticStyle: { width: "400px" } },
                  [
                    _c(
                      "el-form",
                      {
                        staticStyle: { "margin-top": "20px" },
                        attrs: {
                          inline: false,
                          "label-width": "220px",
                          "label-position": "right"
                        }
                      },
                      [
                        _c(
                          "el-form-item",
                          {
                            attrs: {
                              label: _vm.$t("CargoMsg.WHETHER_FINANCIAL_AUDIT")
                            }
                          },
                          [
                            _c(
                              "el-select",
                              {
                                staticStyle: { width: "150px" },
                                attrs: { no: "4", disabled: true },
                                model: {
                                  value: _vm.archivingConfig.financialAlertType,
                                  callback: function($$v) {
                                    _vm.$set(
                                      _vm.archivingConfig,
                                      "financialAlertType",
                                      $$v
                                    )
                                  },
                                  expression:
                                    "archivingConfig.financialAlertType"
                                }
                              },
                              _vm._l(_vm.alertTypes, function(item) {
                                return _c("el-option", {
                                  key: item.code,
                                  attrs: {
                                    label:
                                      _vm.$store.getters.language === "zh"
                                        ? item.chineseName
                                        : item.englishName,
                                    value: item.code
                                  }
                                })
                              }),
                              1
                            )
                          ],
                          1
                        ),
                        _c(
                          "el-form-item",
                          {
                            attrs: { label: _vm.$t("CargoMsg.WHETHER_ACCRUED") }
                          },
                          [
                            _c(
                              "el-select",
                              {
                                staticStyle: { width: "150px" },
                                attrs: { no: "5", disabled: _vm.ifApplied },
                                model: {
                                  value: _vm.archivingConfig.accruedAlertType,
                                  callback: function($$v) {
                                    _vm.$set(
                                      _vm.archivingConfig,
                                      "accruedAlertType",
                                      $$v
                                    )
                                  },
                                  expression: "archivingConfig.accruedAlertType"
                                }
                              },
                              _vm._l(_vm.alertTypes, function(item) {
                                return _c("el-option", {
                                  key: item.code,
                                  attrs: {
                                    label:
                                      _vm.$store.getters.language === "zh"
                                        ? item.chineseName
                                        : item.englishName,
                                    value: item.code
                                  }
                                })
                              }),
                              1
                            )
                          ],
                          1
                        ),
                        _c(
                          "el-form-item",
                          {
                            attrs: {
                              label: _vm.$t(
                                "CargoMsg.FINANCIAL_RECEIVABLES_VERIFICATION"
                              )
                            }
                          },
                          [
                            _c(
                              "el-select",
                              {
                                staticStyle: { width: "150px" },
                                attrs: { no: "6", disabled: _vm.ifApplied },
                                model: {
                                  value:
                                    _vm.archivingConfig
                                      .receivablesVerificationAlertType,
                                  callback: function($$v) {
                                    _vm.$set(
                                      _vm.archivingConfig,
                                      "receivablesVerificationAlertType",
                                      $$v
                                    )
                                  },
                                  expression:
                                    "archivingConfig.receivablesVerificationAlertType"
                                }
                              },
                              _vm._l(_vm.alertTypes, function(item) {
                                return _c("el-option", {
                                  key: item.code,
                                  attrs: {
                                    label:
                                      _vm.$store.getters.language === "zh"
                                        ? item.chineseName
                                        : item.englishName,
                                    value: item.code
                                  }
                                })
                              }),
                              1
                            )
                          ],
                          1
                        ),
                        _c(
                          "el-form-item",
                          {
                            attrs: {
                              label: _vm.$t(
                                "CargoMsg.FINANCIAL_DUE_VERIFICATION"
                              )
                            }
                          },
                          [
                            _c(
                              "el-select",
                              {
                                staticStyle: { width: "150px" },
                                attrs: { no: "7", disabled: _vm.ifApplied },
                                model: {
                                  value:
                                    _vm.archivingConfig
                                      .dueVerificationAlertType,
                                  callback: function($$v) {
                                    _vm.$set(
                                      _vm.archivingConfig,
                                      "dueVerificationAlertType",
                                      $$v
                                    )
                                  },
                                  expression:
                                    "archivingConfig.dueVerificationAlertType"
                                }
                              },
                              _vm._l(_vm.alertTypes, function(item) {
                                return _c("el-option", {
                                  key: item.code,
                                  attrs: {
                                    label:
                                      _vm.$store.getters.language === "zh"
                                        ? item.chineseName
                                        : item.englishName,
                                    value: item.code
                                  }
                                })
                              }),
                              1
                            )
                          ],
                          1
                        ),
                        _c(
                          "el-form-item",
                          {
                            attrs: {
                              label: _vm.$t("CargoMsg.FINANCIAL_CHARGE")
                            }
                          },
                          [
                            _c(
                              "el-select",
                              {
                                staticStyle: { width: "150px" },
                                attrs: { no: "8", disabled: true },
                                model: {
                                  value: _vm.archivingConfig.chargeAlertType,
                                  callback: function($$v) {
                                    _vm.$set(
                                      _vm.archivingConfig,
                                      "chargeAlertType",
                                      $$v
                                    )
                                  },
                                  expression: "archivingConfig.chargeAlertType"
                                }
                              },
                              _vm._l(_vm.alertTypes, function(item) {
                                return _c("el-option", {
                                  key: item.code,
                                  attrs: {
                                    label:
                                      _vm.$store.getters.language === "zh"
                                        ? item.chineseName
                                        : item.englishName,
                                    value: item.code
                                  }
                                })
                              }),
                              1
                            )
                          ],
                          1
                        )
                      ],
                      1
                    )
                  ],
                  1
                )
              ]
            )
          ]
        ),
        _c("div", { staticClass: "division", staticStyle: { height: "97%" } }),
        _c("div", { staticClass: "right", staticStyle: { height: "97%" } }, [
          _c(
            "div",
            { staticStyle: { "margin-top": "50px", "margin-left": "30px" } },
            [
              _c("span", { staticStyle: { "font-size": "18px" } }, [
                _vm._v(
                  _vm._s(_vm.$t("CargoMsg.Financial_Filing_Effective_Effect")) +
                    ":"
                )
              ]),
              _c(
                "div",
                { staticStyle: { width: "300px" } },
                [
                  _c(
                    "el-form",
                    {
                      staticStyle: { "margin-top": "20px" },
                      attrs: {
                        inline: false,
                        "label-width": "150px",
                        "label-position": "right"
                      }
                    },
                    [
                      _c(
                        "el-form-item",
                        {
                          attrs: {
                            label: _vm.$t("CargoMsg.CANCEL_FINANCIAL_AUDIT")
                          }
                        },
                        [
                          _c(
                            "el-select",
                            {
                              staticStyle: { width: "150px" },
                              attrs: { no: "9", disabled: true },
                              model: {
                                value: _vm.effectConfig.cancelFinancialAudit,
                                callback: function($$v) {
                                  _vm.$set(
                                    _vm.effectConfig,
                                    "cancelFinancialAudit",
                                    $$v
                                  )
                                },
                                expression: "effectConfig.cancelFinancialAudit"
                              }
                            },
                            _vm._l(_vm.prohibitedTypes, function(item) {
                              return _c("el-option", {
                                key: item.code,
                                attrs: {
                                  label:
                                    _vm.$store.getters.language === "zh"
                                      ? item.chineseName
                                      : item.englishName,
                                  value: item.code
                                }
                              })
                            }),
                            1
                          )
                        ],
                        1
                      ),
                      _c(
                        "el-form-item",
                        { attrs: { label: _vm.$t("CargoMsg.MODIFY_CHARGE") } },
                        [
                          _c(
                            "el-select",
                            {
                              staticStyle: { width: "150px" },
                              attrs: { no: "10", disabled: true },
                              model: {
                                value: _vm.effectConfig.modifyCharge,
                                callback: function($$v) {
                                  _vm.$set(
                                    _vm.effectConfig,
                                    "modifyCharge",
                                    $$v
                                  )
                                },
                                expression: "effectConfig.modifyCharge"
                              }
                            },
                            _vm._l(_vm.prohibitedTypes, function(item) {
                              return _c("el-option", {
                                key: item.code,
                                attrs: {
                                  label:
                                    _vm.$store.getters.language === "zh"
                                      ? item.chineseName
                                      : item.englishName,
                                  value: item.code
                                }
                              })
                            }),
                            1
                          )
                        ],
                        1
                      ),
                      _c(
                        "el-form-item",
                        { attrs: { label: _vm.$t("CargoMsg.MODIFY_JOB") } },
                        [
                          _c(
                            "el-select",
                            {
                              staticStyle: { width: "150px" },
                              attrs: { no: "11", disabled: true },
                              model: {
                                value: _vm.effectConfig.modifyJob,
                                callback: function($$v) {
                                  _vm.$set(_vm.effectConfig, "modifyJob", $$v)
                                },
                                expression: "effectConfig.modifyJob"
                              }
                            },
                            _vm._l(_vm.prohibitedTypes, function(item) {
                              return _c("el-option", {
                                key: item.code,
                                attrs: {
                                  label:
                                    _vm.$store.getters.language === "zh"
                                      ? item.chineseName
                                      : item.englishName,
                                  value: item.code
                                }
                              })
                            }),
                            1
                          )
                        ],
                        1
                      ),
                      _c(
                        "el-form-item",
                        { attrs: { label: _vm.$t("CargoMsg.MODIFY_RATE") } },
                        [
                          _c(
                            "el-select",
                            {
                              staticStyle: { width: "150px" },
                              attrs: { no: "12", disabled: true },
                              model: {
                                value: _vm.effectConfig.modifyRate,
                                callback: function($$v) {
                                  _vm.$set(_vm.effectConfig, "modifyRate", $$v)
                                },
                                expression: "effectConfig.modifyRate"
                              }
                            },
                            _vm._l(_vm.prohibitedTypes, function(item) {
                              return _c("el-option", {
                                key: item.code,
                                attrs: {
                                  label:
                                    _vm.$store.getters.language === "zh"
                                      ? item.chineseName
                                      : item.englishName,
                                  value: item.code
                                }
                              })
                            }),
                            1
                          )
                        ],
                        1
                      ),
                      _c(
                        "el-form-item",
                        {
                          attrs: {
                            label: _vm.$t("CargoMsg.MODIFY_FINANCE_JOB_DATE")
                          }
                        },
                        [
                          _c(
                            "el-select",
                            {
                              staticStyle: { width: "150px" },
                              attrs: { no: "13", disabled: true },
                              model: {
                                value: _vm.effectConfig.modifyFinanceJobDate,
                                callback: function($$v) {
                                  _vm.$set(
                                    _vm.effectConfig,
                                    "modifyFinanceJobDate",
                                    $$v
                                  )
                                },
                                expression: "effectConfig.modifyFinanceJobDate"
                              }
                            },
                            _vm._l(_vm.prohibitedTypes, function(item) {
                              return _c("el-option", {
                                key: item.code,
                                attrs: {
                                  label:
                                    _vm.$store.getters.language === "zh"
                                      ? item.chineseName
                                      : item.englishName,
                                  value: item.code
                                }
                              })
                            }),
                            1
                          )
                        ],
                        1
                      ),
                      _c(
                        "el-form-item",
                        {
                          directives: [
                            {
                              name: "show",
                              rawName: "v-show",
                              value: false,
                              expression: "false"
                            }
                          ],
                          attrs: {
                            label: _vm.$t("CargoMsg.GENERATE_RED_INVOICE")
                          }
                        },
                        [
                          _c(
                            "el-select",
                            {
                              staticStyle: { width: "150px" },
                              attrs: { no: "14", disabled: true },
                              model: {
                                value: _vm.effectConfig.generateRedInvoice,
                                callback: function($$v) {
                                  _vm.$set(
                                    _vm.effectConfig,
                                    "generateRedInvoice",
                                    $$v
                                  )
                                },
                                expression: "effectConfig.generateRedInvoice"
                              }
                            },
                            _vm._l(_vm.prohibitedTypes, function(item) {
                              return _c("el-option", {
                                key: item.code,
                                attrs: {
                                  label:
                                    _vm.$store.getters.language === "zh"
                                      ? item.chineseName
                                      : item.englishName,
                                  value: item.code
                                }
                              })
                            }),
                            1
                          )
                        ],
                        1
                      ),
                      _c(
                        "el-form-item",
                        {
                          directives: [
                            {
                              name: "show",
                              rawName: "v-show",
                              value: false,
                              expression: "false"
                            }
                          ],
                          attrs: {
                            label: _vm.$t(
                              "CargoMsg.RECEIVABLE_GENERATES_INVOICE"
                            )
                          }
                        },
                        [
                          _c(
                            "el-select",
                            {
                              staticStyle: { width: "150px" },
                              attrs: { no: "15", disabled: _vm.ifApplied },
                              model: {
                                value:
                                  _vm.effectConfig.receivableGeneratesInvoice,
                                callback: function($$v) {
                                  _vm.$set(
                                    _vm.effectConfig,
                                    "receivableGeneratesInvoice",
                                    $$v
                                  )
                                },
                                expression:
                                  "effectConfig.receivableGeneratesInvoice"
                              }
                            },
                            _vm._l(_vm.prohibitedTypes, function(item) {
                              return _c("el-option", {
                                key: item.code,
                                attrs: {
                                  label:
                                    _vm.$store.getters.language === "zh"
                                      ? item.chineseName
                                      : item.englishName,
                                  value: item.code
                                }
                              })
                            }),
                            1
                          )
                        ],
                        1
                      ),
                      _c(
                        "el-form-item",
                        {
                          directives: [
                            {
                              name: "show",
                              rawName: "v-show",
                              value: false,
                              expression: "false"
                            }
                          ],
                          attrs: {
                            label: _vm.$t("CargoMsg.COPE_GENERATES_INVOICE")
                          }
                        },
                        [
                          _c(
                            "el-select",
                            {
                              staticStyle: { width: "150px" },
                              attrs: { no: "16", disabled: _vm.ifApplied },
                              model: {
                                value: _vm.effectConfig.copeGeneratesInvoice,
                                callback: function($$v) {
                                  _vm.$set(
                                    _vm.effectConfig,
                                    "copeGeneratesInvoice",
                                    $$v
                                  )
                                },
                                expression: "effectConfig.copeGeneratesInvoice"
                              }
                            },
                            _vm._l(_vm.prohibitedTypes, function(item) {
                              return _c("el-option", {
                                key: item.code,
                                attrs: {
                                  label:
                                    _vm.$store.getters.language === "zh"
                                      ? item.chineseName
                                      : item.englishName,
                                  value: item.code
                                }
                              })
                            }),
                            1
                          )
                        ],
                        1
                      ),
                      _c(
                        "el-form-item",
                        {
                          directives: [
                            {
                              name: "show",
                              rawName: "v-show",
                              value: false,
                              expression: "false"
                            }
                          ],
                          attrs: {
                            label: _vm.$t(
                              "CargoMsg.CANCEL_RECEIVABLE_VERIFICATION"
                            )
                          }
                        },
                        [
                          _c(
                            "el-select",
                            {
                              staticStyle: { width: "150px" },
                              attrs: { no: "17", disabled: _vm.ifApplied },
                              model: {
                                value:
                                  _vm.effectConfig.cancelReceivableVerification,
                                callback: function($$v) {
                                  _vm.$set(
                                    _vm.effectConfig,
                                    "cancelReceivableVerification",
                                    $$v
                                  )
                                },
                                expression:
                                  "effectConfig.cancelReceivableVerification"
                              }
                            },
                            _vm._l(_vm.prohibitedTypes, function(item) {
                              return _c("el-option", {
                                key: item.code,
                                attrs: {
                                  label:
                                    _vm.$store.getters.language === "zh"
                                      ? item.chineseName
                                      : item.englishName,
                                  value: item.code
                                }
                              })
                            }),
                            1
                          )
                        ],
                        1
                      ),
                      _c(
                        "el-form-item",
                        {
                          directives: [
                            {
                              name: "show",
                              rawName: "v-show",
                              value: false,
                              expression: "false"
                            }
                          ],
                          attrs: {
                            label: _vm.$t(
                              "CargoMsg.COPE_RECEIVABLE_VERIFICATION"
                            )
                          }
                        },
                        [
                          _c(
                            "el-select",
                            {
                              staticStyle: { width: "150px" },
                              attrs: { no: "18", disabled: _vm.ifApplied },
                              model: {
                                value:
                                  _vm.effectConfig.copeReceivableVerification,
                                callback: function($$v) {
                                  _vm.$set(
                                    _vm.effectConfig,
                                    "copeReceivableVerification",
                                    $$v
                                  )
                                },
                                expression:
                                  "effectConfig.copeReceivableVerification"
                              }
                            },
                            _vm._l(_vm.prohibitedTypes, function(item) {
                              return _c("el-option", {
                                key: item.code,
                                attrs: {
                                  label:
                                    _vm.$store.getters.language === "zh"
                                      ? item.chineseName
                                      : item.englishName,
                                  value: item.code
                                }
                              })
                            }),
                            1
                          )
                        ],
                        1
                      ),
                      _c(
                        "el-form-item",
                        { attrs: { label: _vm.$t("CargoMsg.MODIFY_ACCRUAL") } },
                        [
                          _c(
                            "el-select",
                            {
                              staticStyle: { width: "150px" },
                              attrs: { no: "19", disabled: _vm.ifApplied },
                              model: {
                                value: _vm.effectConfig.modifyAccrual,
                                callback: function($$v) {
                                  _vm.$set(
                                    _vm.effectConfig,
                                    "modifyAccrual",
                                    $$v
                                  )
                                },
                                expression: "effectConfig.modifyAccrual"
                              }
                            },
                            _vm._l(_vm.prohibitedTypes, function(item) {
                              return _c("el-option", {
                                key: item.code,
                                attrs: {
                                  label:
                                    _vm.$store.getters.language === "zh"
                                      ? item.chineseName
                                      : item.englishName,
                                  value: item.code
                                }
                              })
                            }),
                            1
                          )
                        ],
                        1
                      )
                    ],
                    1
                  )
                ],
                1
              )
            ]
          )
        ])
      ]
    )
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }